// client/src/hooks/useTransactions.js
// Read-only listing of a camp's transactions. The back-office only reads
// these — the write side is the terminal API (wave 3).

import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api.js';

export function useTransactions(campId, query = {}, options = {}) {
  return useQuery({
    queryKey: ['camps', campId, 'transactions', query],
    queryFn: () => api.get(`/api/camps/${campId}/transactions`, { query }),
    enabled: !!campId && (options.enabled ?? true),
    placeholderData: (prev) => prev,
  });
}
